export const TAX_ENTRY_ACCOUNT_ID = 'STMARESERV - Reserve-TPC';

export const AMOUNT_HAS_CHANGED_ERROR_MESSAGE = 'Enter a new balance or click outside the dialog to cancel.';
export const AMOUNT_HAS_CHANGED_FIELD_NAME = 'amountHasChanged';
